import type { Ceviri, MotorP } from "../../tip";
import type { sanal as tr } from "../../tr/motor/sanal";

/** ISO day (2026-01-05) → 05/01/2026. */
const gun = (iso: string | undefined): string =>
  iso === undefined || iso.length < 10 ? String(iso) : `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;

/** English dictionary · engine messages · sanal. */
export const sanal: Ceviri<typeof tr> = {
  "sanal.cekimKarsilanamadi": (p: MotorP) =>
    `Withdrawal not fully met: requested ${p.istenen} ${p.para}, withdrawn ${p.cekilen} ${p.para} (no assets left to sell).`,
  "sanal.temettuParaBirimiBilinmiyor": (p: MotorP) => `${p.varlik} dividend currency is unknown; not added to the account.`,
  "sanal.paraGirisiYok": () => "The selected accounts have no deposits or purchases in this range.",
  "sanal.temettuBilgisiYok": (p: MotorP) => `No dividend data for ${p.varlik}; dividends not added to the account.`,
  "sanal.temettuKapsami": (p: MotorP) =>
    `${p.varlik} dividend data covers only ${gun(p.from)}–${gun(p.to)}; dividends outside it were not added to the account.`,
  "sanal.temettuTutariYok": (p: MotorP) => `The source has no amount for the ${p.varlik} dividend; not added to the account.`,
  "sanal.payYetmediNakitte": (p: MotorP) =>
    `${p.varlik}: in ${p.sayi} purchases the allocated share (fee included) was not enough to buy; the money stayed in cash.`,
  "sanal.payYetmediKusurata": (p: MotorP) =>
    `${p.varlik}: in ${p.sayi} purchases the allocated share (fee included) was not enough to buy; the money went to the asset bought in fractions.`,
  "sanal.islemGunuGelmedi": () => "No trading day has come up to this date; no transactions.",
  "sanal.durdurKurYok": (p: MotorP) => `No ${p.base}/${p.quote} exchange rate for ${gun(p.tarih)}.`,
  "sanal.durdurKaynaktaFiyatYok": (p: MotorP) =>
    `No price at the source for ${p.varlik} on or before ${gun(p.tarih)}; the start cannot be earlier than this asset's first price day.`,
  "sanal.durdurFiyatIndirilmedi": (p: MotorP) => `The ${gun(p.tarih)} price for ${p.varlik} has not been downloaded yet.`,
  "sanal.durdurParaBirimiBilinmiyor": (p: MotorP) => `${p.varlik}: currency unknown.`,
  "sanal.durdurFiyatSifir": (p: MotorP) => `${p.varlik}: price on ${gun(p.tarih)} is zero.`,
};
